<template>
  <tr>
    <td class="ac has-radio">
      <div class="c-radio">
        <input
          type="radio"
          :id="selectRadioId"
          :checked="props.address.selected"
          @click="() => emits('select', props.address.dlvdesSn)"
        />
        <label :for="selectRadioId">
          <span class="sr-only">선택</span>
        </label>
      </div>
    </td>
    <td>
      <span
        v-if="props.address.bscDlvdesYn === 'Y'"
        class="c-round-flag type-primary type-small"
      >
        기본배송지
      </span>
      <br v-if="props.address.bscDlvdesYn === 'Y'" />
      {{ props.address.dlvdesNm || "-" }}
    </td>
    <td class="ac">{{ props.address.acptrNm }}</td>
    <td>
      <span class="phone"> ({{ props.address.zip }}) </span>
      <span class="address">
        {{ props.address.roadNmBscAddr }} {{ props.address.roadNmDtlAddr }}
      </span>
    </td>
    <td>
      <span class="phone">{{ props.address.acptrWrdTelno }}</span>
      <span class="phone">{{ props.address.acptrMblTelno }}</span>
    </td>
    <td class="ac">
      <div v-if="props.address.bscDlvdesYn === 'N'" class="c-btn-area flex-ac">
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="() => emits('edit', props.address)"
        >
          <span>수정</span>
        </button>
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="() => emits('delete', props.address)"
        >
          <span>삭제</span>
        </button>
      </div>
    </td>
  </tr>
</template>
<script setup>
import { onMounted, defineProps, defineEmits } from "vue";
import { v4 as uuidv4 } from "uuid";

const props = defineProps({
  address: {
    type: Object,
    required: true,
  },
});

const selectRadioId = uuidv4();

const emits = defineEmits(["select", "edit", "delete"]);

onMounted(() => {});
</script>
